/*
Archives component
*/

import React, { Component } from 'react';
import axios from 'axios';
import { forwardRef } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';

//import styled from 'styled-components';
import ModalConfirmRestoreRequete from '../ModalConfirmRestoreRequete/ModalConfirmRestoreRequete'

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import './Archives.css'
import {globals, defaultMaterialTheme} from '../Globals/Globals'
import { ThemeProvider } from "@material-ui/styles";

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
  };

class Archives extends Component{
    constructor(props){
        super(props);
        this.state = {
          requests:[], 
          selected_subject:null, 
          openPublication:false, 
          filter_rubrique_id: -1, 
          filter_etat_id:-1,
          filter_idenvois:-1};

        this.materialTableRef = React.createRef();
        this.togglePublication = this.togglePublication.bind(this);
    }

    componentDidMount = () => {
      this.service_db_url =  globals.parameters.local?'http://localhost:4001/requetes-page-archives'
                          :`https://requetes.jesusestlareponsepourtous.org/requetes-page-archives`;
    }

    refreshMaterialTable = () => {
      if (this.materialTableRef.current)
        this.materialTableRef.current.onQueryChange();
      else
        console.error("refreshMaterialTable failed");
    }

    togglePublication() {    
        this.setState({openPublication:!this.state.openPublication}, ()=>{console.log("togglePublication =>", this.state.openPublication)});
        //refresh table on publication modal close
        this.refreshMaterialTable();
    }

    OnChangeRubriqueFilter = (selected_rubrique) => {
      this.setState({
        filter_rubrique_id:selected_rubrique.idrubriques}, 
        ()=>{this.refreshMaterialTable(); console.log("selected rubrique;",selected_rubrique)});
    }

    OnChangeEtatFilter = (selected_etat) => {
      this.setState({
        filter_etat_id:selected_etat.idetats}, 
        ()=>{this.refreshMaterialTable(); console.log("selected etat;",selected_etat)});
    }

    OnChangeBookletFilter = (selected_booklet) => {
      this.setState({
        filter_idenvois:selected_booklet.idenvois}, 
        ()=>{this.refreshMaterialTable(); console.log("selected booklet;",selected_booklet)});
    }

    requestItemRendered = (request) => {
        if (!request)
            return(<span>Choisir une requete ...</span>)
        else
            return(
                <span>                        
                    <span>&nbsp;{request.time_stamp} : </span> 
                    <span>&nbsp;{request.nom},</span> 
                    <span>&nbsp;{request.prenom},</span> 
                    <span>&nbsp;{request.email},</span> 
                    <span>&nbsp;{request.tel},</span> 
                    <span>&nbsp;{request.sujet_requete},</span> 
                    <span>&nbsp;{request.beneficiaire}</span> 
                </span>
            );
    }

    RemoteData = () => {
        return (
          <div>
          <ThemeProvider theme={defaultMaterialTheme}>
          <MaterialTable
            tableRef={this.materialTableRef}
            icons={tableIcons}
            title="Retranscriptions."
            actions={[
                rowData => ({
                    icon: () => <ModalConfirmRestoreRequete 
                                  modal={this.state.openPublication} 
                                  toggle={this.togglePublication} 
                                  data={this.state.data_selection} 
                                  refreshHandler={this.refreshMaterialTable}/>,
                    tooltip: 'Restauratiion des requêtes...',
                    onClick: (evt, data) => {
                                              //alert('You want to PUBLISH ' + data.length + ' rows');
                                              this.setState({data_selection:data},()=>{this.setState({openPublication:true}, ()=>{console.clear(); console.log("new state", this.state);})})
                                            }
                })
              ]}
              
            options={{
                selection: true,
                search: true,
                /*grouping: true, 2DO later*/
                grouping: false,
                showTitle: false,
                actionsColumnIndex: -1
              }}
              
            columns={[
              { title: 'Date de création', field: 'time_stamp_fr' },
              /*
              { title: 'Pays', field: 'titre_pays' },*/
              { title: 'Rubrique', field: 'titre_rubrique' },
              /*
              { 
                title: 'Chaîne de prière', 
                field: 'chaine_de_priere',
                render: rowData => (
                  <span>{rowData.chaine_de_priere == 1?"Oui":"Non"}</span>
                ) 
              },*/
              /*
              { title: 'Etat', field: 'titre_etat' },*/
              { 
                  title: 'Demandeur', 
                  field: 'prenom_demandeur', 
              },
              { title: 'Bénéficiaire', field: 'beneficiaire' },

              {
                title: 'Requête',
                field: 'sujet_revise',
              },
            ]}

            data={query =>
              new Promise((resolve, reject) => {
                let url = `${this.service_db_url}`;

                //-- pagination support
                url += '?size=' + query.pageSize; //Set number of records by page
                url += '&offset=' + (query.page) * query.pageSize //Compute first record offset for requested page
                
                if ((query.orderBy) && (query.orderBy != "undefined") && (query.orderBy.field)){
                  url += `&order_by_clause= order by ${query.orderBy.field.replace("time_stamp_fr","time_stamp")} ${query.orderDirection}`//Order by management
                }
                else{
                  url += "&order_by_clause="
                }
                
                if (query.search.trim().length > 0){
                  url += `&where_clause= where ((INSTR(beneficiaire,'${query.search.trim()}') > 0) || (INSTR(sujet_revise,'${query.search.trim()}') > 0))`
                }
                else{
                  url += `&where_clause= where true`;
                }

                if (this.state.filter_rubrique_id != -1){
                  url += ` and (idrubriques = ${this.state.filter_rubrique_id})`
                }

                if (this.state.filter_etat_id != -1){
                  url += ` and (idetats = ${this.state.filter_etat_id})`
                }

                if (this.state.filter_idenvois != -1){
                  url += ` and (he.idenvois = ${this.state.filter_idenvois})`
                }

                console.log("filter_url:",url)


                fetch(url)
                  .then(response => response.json())
                  .then(result => {
                    resolve({
                      data: result.items,
                      page: query.page,//Current page
                      totalCount: result.items.length>0?result.items[0].total_count:0,
                    })
                  })
              })
            }
          />
          </ThemeProvider>
          </div>
        )
      }
      
    render(){
            return (<div>{this.RemoteData()}</div>);
    }
}

export default Archives;